// Who may rotate a single sample's core line, and when.
//
// The action edits one sample's cluster in place, so it is offered only where
// that cluster is a line the mapmaker owns and nothing has been sampled yet:
// mapmaking (not sampling), grid missions (zone cores are placed inside a zone,
// not on a line), the LINE pattern, on a pending sample whose cores are ALL
// still unpulled, with at least two cores to define the line.
import { GridPatterns } from '../../../db';
import { KmlFeatureType, KML_FEATURE_TYPE } from '../../../featureTypes';
import { MAP_TYPES, MapType } from './mapTypes';

export interface RotateCoreLineEligibility {
  mapType: MapType;
  /** True when the mission's pattern is ZONE (cores are placed inside a zone). */
  zoneMission: boolean;
  patternType: number;
  /** The selected feature's type, from `getFeatureType`. */
  featureType: KmlFeatureType | undefined;
  /** `Sample.isPending()` — false for skipped, deleted, scanned or fully-pulled samples. */
  samplePending: boolean;
  /** No core of the sample has been pulled yet — nothing recorded to disturb. */
  allCoresUnpulled: boolean;
  coreCount: number;
}

/** True when the sample popup should offer "Rotate core line" for this selection. */
export function canRotateCoreLine({
  mapType,
  zoneMission,
  patternType,
  featureType,
  samplePending,
  allCoresUnpulled,
  coreCount,
}: RotateCoreLineEligibility): boolean {
  return (
    mapType === MAP_TYPES.MAPS &&
    !zoneMission &&
    patternType === GridPatterns.LINE &&
    featureType === KML_FEATURE_TYPE.CENTROID &&
    samplePending &&
    allCoresUnpulled &&
    coreCount >= 2
  );
}
